module.exports = __webpack_public_path__ + "img/wallpaper-6.64fe2b5d.png";